// BASIC COLROS
export const COLOR_PRIMARY = '#191970'
export const COLOR_RED = '#f9303e'
export const COLOR_GREEN = '#BBDAC9'
export const COLOR_OTHER_GREEN = '#C3E9E9'
export const COLOR_VERT_MOBIVILLE = '#37B4B4'
export const COLOR_GREY = '#808080'
export const COLOR_LIGHT_GREY = '#E4E9ED'
export const COLOR_GRAY = '#F6F7FB'
export const COLOR_SALMON = '#FCA890'
export const COLOR_WHITE = '#FFFFFF'
export const COLOR_PURPLE = '#C7C7F3'
export const COLOR_LIGHT_PURPLE = '#EBEDF8'

// TEXT
export const COLOR_TEXT_PRIMARY = '#23333E'
export const COLOR_TEXT_SECONDARY = '#657078'

// BACKGROUNDS
export const COLOR_BACKGROUND = COLOR_GRAY
export const COLOR_HEADER_BACKGROUND = '#F6F7FB'
export const COLOR_SECONDARY = '#336E7B'

// BUTTONS
export const COLOR_BUTTON_HOVER = '#4E4EC9'

// TAGS
export const COLOR_TAG_GREEN = COLOR_OTHER_GREEN
export const COLOR_TAG_RED = '#F1B3B7'
